import type { FunctionComponent } from "react";
import {
  DesktopLayoutDefault,
  DesktopLayoutDefaultContent,
} from "@kanda-libs/ks-design-library";
import LeadDetails from "components/lead/LeadLayout/LeadDetails";
import LeadBanner from "components/lead/LeadLayout/LeadBanner";

const LeadLayout: FunctionComponent = function ({}) {
  return (
    <DesktopLayoutDefault>
      <DesktopLayoutDefaultContent>
        <LeadBanner />
        <LeadDetails />
      </DesktopLayoutDefaultContent>
    </DesktopLayoutDefault>
  );
};

export default LeadLayout;
